import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible'
import router from './router.js'
import axios from 'axios'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

//全局定义axios
//axios.defaults.baseURL = 'http://testlive.zgwstxc.com/apis/' //测试
axios.defaults.baseURL = 'https://api.zgwstxc.com/apis/' //正式
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
Vue.prototype.$http = axios

Vue.config.productionTip = false

// 打开新路由时置顶
router.beforeEach((to, from, next) => {
    // chrome
    document.body.scrollTop = 0
    // firefox
    document.documentElement.scrollTop = 0
    // safari
    window.pageYOffset = 0
    next()
})
/* 全局混入*/
mixin(Vue);
new Vue({
    router,
    render: h => h(App),
}).$mount('#app')

/* 全局混入*/
function mixin(Vue) {
    Vue.mixin({
        data() {
            return {
                imageUrl: 'http://img.zgwstxc.com'
            }
        }
    })
}